import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from '@/i18n'
import { GetBusinessTemplateCategory } from '@/utils/Global'

import './index.scss'

class BusinessCategory extends Component {

    getBusinessCategory = () => {
        const BUSINESS_TEMPLATE_CATEGORY = GetBusinessTemplateCategory()
        const businessItems = [
            {
                title: i18n.t("categoryfiltering.businesscategory.title"),
                type: "default",
                filterName: 'businessCategory',
                items: [
					BUSINESS_TEMPLATE_CATEGORY.All,
                    BUSINESS_TEMPLATE_CATEGORY.Beauty,
                    BUSINESS_TEMPLATE_CATEGORY.Fashion,
                    BUSINESS_TEMPLATE_CATEGORY.Ecommerce_Shopping,
                    BUSINESS_TEMPLATE_CATEGORY.Cafe_Food_Bakery,
                    BUSINESS_TEMPLATE_CATEGORY.Lodging_Trabel_Leisure,
                    BUSINESS_TEMPLATE_CATEGORY.Health_Sports,
                    BUSINESS_TEMPLATE_CATEGORY.Realestate,
                    BUSINESS_TEMPLATE_CATEGORY.EduAcademy,
                    BUSINESS_TEMPLATE_CATEGORY.DynamicShorts,
                    BUSINESS_TEMPLATE_CATEGORY.Medical_Professional,
                    BUSINESS_TEMPLATE_CATEGORY.Event_Promo,
                    BUSINESS_TEMPLATE_CATEGORY.VLog,
                    BUSINESS_TEMPLATE_CATEGORY.YoutubeTitle,
                    BUSINESS_TEMPLATE_CATEGORY.Others,
                ]
            }
        ]
        return businessItems
    }

    renderItems = item => {
        const { type, filterName, items } = item
        const { filter, handleChangeFilter, lang} = this.props

        switch (type) {
            default:
                return items.map(item => {
                    const { label, key } = item

                    const onClickHandler = () => handleChangeFilter({
                        name: filterName,
                        key
                    })
                    const isActive = filter[filterName] && filter[filterName][key]

                    return (
                        <div
                            className={`item ${isActive && 'active'}`}
                        >
                            <div className={`item-label ${lang}`} onClick={onClickHandler}># {label}</div>
                        </div>
                    )
                })
        }
    }

    render() {
        const businessItems = this.getBusinessCategory()

        return (
            <div className="business-category-root-container">
                <div className="filter-container">
                    {
                        businessItems.map(item => {
                            const { title, type, customItems } = item
                            return (
                                <div className="item-wrapper">
                                    <div className="title">{title}</div>
                                    <div className={`items ${type}`}>
                                        {this.renderItems(item)}
                                        {customItems}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(BusinessCategory)